<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 15 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g transform="matrix(1.05055,0,0,1.43406,0.123016,-0.609038)">
        <rect x="0" y="10.5" width="14" height="1" style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.05055,0,0,1.43406,0.123016,-0.609038)">
        <rect x="2" y="8" width="10" height="1" style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.05055,0,0,1.43406,0.123016,-0.609038)">
        <rect x="0" y="5.5" width="14" height="1" style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.05055,0,0,1.43406,0.123016,-0.609038)">
        <rect x="0" y="0.5" width="14" height="1" style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.05055,0,0,1.43406,0.123016,-0.609038)">
        <rect x="2" y="3" width="10" height="1" style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AlignCenterIcon'
}
</script>
